// extracted by mini-css-extract-plugin
export default {"menuWrapper":"Header_menuWrapper__7U50x","siteHeader":"Header_siteHeader__y2dMs","isPopupOpened":"Header_isPopupOpened__xOiMo"};